//views
// import AppointmentForm from "@/views/personalCenter/appointmentForm.vue";
import PersonalCenterPage from "@/views/personalCenter/personalCenterPage.vue";
import Questionnaire from "@/views/customer/questionnaire.vue"; //顾客问卷调查
import Loadingpage from "@/views/home/loadingpage.vue";
import Nobind from "@/views/personalCenter/nobind.vue";
import Errorpage from "@/views/home/errorpage.vue";
import Mobile from "@/views/home/index.vue";
import Home from "@/views/home/home.vue";
import page503 from "@/views/503.vue";
import PC from "@/views/pc/index.vue";
//util
import { createRouter, createWebHistory } from "vue-router";
import { navStore } from "@/store/nav.js";
import { userStore } from "@/store/user";
import func from "@/util/func";

//顾客页面白名单：这些页面走顾客授权逻辑，不执行员工端 wxLogin
export const CUSTOMER_PAGE_PATH_LIST = ["/questionnaire", "/bindSCRM"];

const routes = [
  {
    path: "/",
    redirect: "/mobile",
    component: Home,
    children: [
      {
        path: "/mobile",
        name: "mobile",
        component: Mobile,
      },
      {
        path: "/personalCenterPage",
        name: "personalCenterPage",
        component: PersonalCenterPage,
      },
      {
        path: "/personalCenter/appointmentForm",
        name: "personalCenterAppointmentForm",
        component: () => import("../views/personalCenter/appointmentForm.vue"),
      },
      {
        // 新建预约页（与 appointmentForm 同级挂在其下方路由）
        path: "/personalCenter/appointmentForm/createAppoint",
        name: "personalCenterCreateAppoint",
        component: () =>
          import(
            "../views/personalCenter/createAppoint/createAppoint.vue"
          ),
      },
      {
        path: "/personalCenter/cancelAppointmentForm",
        name: "cancelAppointmentForm",
        component: () =>
          import("../views/personalCenter/cancelAppointmentForm.vue"),
      },
      {
        path: "/nobind",
        name: "noBind",
        component: Nobind,
      },
      {
        path: "/503",
        name: "503",
        component: page503,
      },
      {
        path: "/entrypage",
        name: "entrypage",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/home/entrypage.vue"),
      },
      {
        path: "/groupChatEntrance",
        name: "groupChatEntrance",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/group/groupChatEntrance.vue"
          ),
      },
      {
        //推送页面
        path: "/pushPage",
        name: "pushPage",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/other/pushPage.vue"),
      },
      {
        //待办任务
        path: "/waitingProcessing",
        name: "waitingProcessing",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/other/waitingProcessing.vue"
          ),
      },
      {
        //企微应用首页
        path: "/wecomAppHomePage",
        name: "wecomAppHomePage",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../views/other/wecomAppHomePage.vue"
          ),
      },
      {
        //绑定蓝莓熊
        path: "/bindSCRM",
        name: "bindSCRM",
        component: () =>
          import(
            /* webpackChunkName: "bindSCRM" */ "../views/other/bindSCRM.vue"
          ),
      },
      {
        path: "/questionnaire",
        name: "questionnaire",
        component: Questionnaire,
      },
      {
        //批量添加到组
        path: "/joinGroup",
        name: "joinGroup",
        children: [
          {
            path: "/batchAddToGroups",
            name: "batchAddToGroups",
            component: () =>
              import(
                /* webpackChunkName: "batchAddToGroups" */ "../views/other/joinGroup/batchAddToGroups.vue"
              ),
          },
        ],
      },
      {
        //话书库
        path: "/scriptLib",
        name: "scriptLib",
        component: () =>
          import(
            /* webpackChunkName: "scriptLib" */ "../views/other/scriptLib/index.vue"
          ),
      },
      {
        //素材库
        path: "/materialLibrary",
        name: "materialLibrary",
        children: [
          {
            path: "materialList",
            name: "materialList",
            component: () =>
              import(
                /* webpackChunkName: "materialLibrary" */ "../views/other/materialLibrary/materialList.vue"
              ),
          },
          {
            path: "articlePreview",
            name: "articlePreview",
            component: () =>
              import(
                /* webpackChunkName: "materialLibrary" */ "../views/other/materialLibrary/articlePreview.vue"
              ),
          },
          // 新增二级目录页面路由
          {
            path: "subdirectory/:directoryId",
            name: "materialSubDirectory",
            component: () =>
              import(
                /* webpackChunkName: "materialLibrary" */ "../views/other/materialLibrary/materialList.vue"
              ),
          },
          // 新增三级目录页面路由
          {
            path: "subdirectory/:directoryId/level/:level",
            name: "materialThirdDirectory",
            component: () =>
              import(
                /* webpackChunkName: "materialLibrary" */ "../views/other/materialLibrary/materialList.vue"
              ),
          },
        ],
      },
      {
        //报告检查
        path: "/reportCheckMobile",
        redirect: "/reportCheckMobile/selectClinic",
        children: [
          {
            path: "selectClinic",
            name: "reportCheckMobileSelectClinic",
            component: () =>
              import("../views/reportCheck/mobile/selectClinic.vue"),
          },
          {
            path: "list",
            name: "reportCheckMobileList",
            component: () => import("../views/reportCheck/mobile/list.vue"),
          },
          {
            path: "details",
            name: "reportCheckMobileDetails",
            component: () => import("../views/reportCheck/mobile/details.vue"),
          },
        ],
      },
      {
        //跟进计划
        path: "/todayTodo",
        name: "todayTodo",
        component: () =>
          import(
            /* webpackChunkName: "todayTodo" */ "../views/personalCenter/todayTodo/personalCreateToday.vue"
          ),
        children: [
          {
            path: "create",
            name: "todayTodoCreate",
            component: () =>
              import(
                /* webpackChunkName: "todayTodo" */ "../views/personalCenter/todayTodo/create.vue"
              ),
          },
          {
            path: "regCommStatus",
            name: "todayTodoRegCommStatus",
            component: () =>
              import(
                /* webpackChunkName: "todayTodo" */ "../views/personalCenter/todayTodo/regCommStatus.vue"
              ),
          },
          {
            path: "register",
            name: "registerCommStatus",
            component: () =>
              import(
                /* webpackChunkName: "todayTodo" */ "../views/personalCenter/todayTodo/registerCommStatus.vue"
              ),
          },
        ],
      },
      //建群第一步
      {
        path: "/createGroup/step1",
        name: "createGroupStep1",
        component: () =>
          import(
            /* webpackChunkName: "createGroup" */ "../views/personalCenter/createGroup/createGroupstep1.vue"
          ),
      },
      //建群第二步
      {
        path: "/createGroup/step2",
        name: "createGroupStep2",
        component: () =>
          import(
            /* webpackChunkName: "createGroup" */ "../views/personalCenter/createGroup/createGroupstep2.vue"
          ),
      },
    ],
  },
  {
    path: "/pc",
    component: PC,
    children: [
      {
        //工作台重定向到 clinicWorkspace
        path: "workspace",
        redirect: { name: "clinicWorkspacePc" },
      },
      {
        //PC端空白页
        path: "entry",
        name: "entry",
        component: () => import("../views/pc/entry.vue"),
      },
      {
        //门店工作台
        path: "clinicWorkspace",
        name: "clinicWorkspacePc",
        component: () => import("../views/pc/clinicWorkspace/index.vue"),
      },
      {
        //我的待办
        path: "myWorkspace",
        name: "myWorkspacePc",
        component: () => import("../views/pc/myWorkspace/index.vue"),
      },
      {
        //统计报表
        path: "statisticsReport",
        name: "statisticsReportPc",
        component: () => import("../views/pc/statisticsReport/index.vue"),
      },
      {
        //数据报表
        path: "dataReport",
        name: "dataReportPc",
        component: () => import("../views/pc/dataReport/index.vue"),
      },
      {
        //客户管理
        path: "customerManagement",
        name: "customerManagementPc",
        component: () => import("../views/pc/customerManagement/index.vue"),
      },
      {
        //线索管理
        path: "clueManagement",
        name: "clueManagementPc",
        component: () => import("../views/pc/clueManagement/index.vue"),
      },
      {
        //好友线索管理
        path: "friendManagement",
        name: "friendManagementPc",
        component: () => import("../views/pc/friendManagement/index.vue"),
      },
      {
        //群聊管理
        path: "groupChat",
        name: "groupChatPc",
        component: () => import("../views/pc/groupChat/index.vue"),
      },
      {
        //管理
        path: "manage",
        name: "managePc",
        component: () => import("../views/pc/manage/index.vue"),
      },
      {
        //企微聊天工作台
        path: "wecomChat",
        name: "wecomChatPc",
        component: () => import("../views/pc/wecomChat/index.vue"),
      },
      {
        //跟进计划
        path: "followUpPlan",
        name: "followUpPlanPc",
        component: () => import("../views/pc/followUpPlan/index.vue"),
      },
      {
        //报告检查
        path: "reportCheck",
        redirect: "/pc/reportCheck/index",
        children: [
          {
            path: "selectClinic",
            name: "reportCheckPcSelectClinic",
            component: () => import("../views/pc/reportCheck/selectClinic.vue"),
          },
          {
            path: "index",
            name: "reportCheckPcIndex",
            component: () => import("../views/pc/reportCheck/index.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/loading",
    name: "loadingpage",
    component: Loadingpage,
  },
  {
    path: "/errorpage",
    name: "errorpage",
    component: Errorpage,
  },
  {
    path: "/clearStorage",
    name: "clearStorage",
    component: () =>
      import(
        /* webpackChunkName: "clearStorage" */ "../views/other/clearStorage.vue"
      ),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

//路由守卫

router.beforeEach((to, from, next) => {
  const userstore = userStore();
  const navstore = navStore();
  //无需判断是否有用户信息的情况
  let NoTestUserPage = ["loadingpage", "errorpage"];

  let hasUserinfo = !func.isEmpty(userstore.userInfo);
  next();

  // if(!NoTestUserPage.includes(to.name)&&!hasUserinfo){
  //   next({ name:'errorpage'})
  // }else{
  //   next()
  // }
});

export default router;
